// extracted by mini-css-extract-plugin
export default {"container":"DeliveryAddress_container__1lJSZ"};